import { isModalOpenAtom, modalCancelableAtom, modalChildrenAtom } from '@states/uiAtoms';
import { useAtom, useSetAtom } from 'jotai';
import { ReactNode, useEffect } from 'react';

function useModal() {
  const [open, setOpen] = useAtom(isModalOpenAtom);
  const setChildren = useSetAtom(modalChildrenAtom);
  const setCancelable = useSetAtom(modalCancelableAtom);
  const openModal = (children: ReactNode, cancelable?: boolean) => {
    setChildren(children);
    setOpen(true);
    setCancelable(cancelable || false);
  };
  const closeModal = () => {
    setOpen(false);
  };
  useEffect(() => {
    document.body.style.overflowY = open ? 'hidden' : 'auto';
  }, [open]);
  return {
    openModal, closeModal,
  };
}

export default useModal;
